module["exports"] = [
  "Ramsay Street",
  "Bonnie Doon",
  "Cavill Avenue",
  "Queen Street"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en_au_ocker/address/street_root.js
// module id = 1440
// module chunks = 1